import { FPS } from '../constants'
import { CreationToolFrame } from '../types'

const drawToCanvas = (video: HTMLVideoElement): HTMLCanvasElement => {
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d', { alpha: false })
    canvas.width = video.videoWidth
    canvas.height = video.videoHeight
    context?.drawImage(video, 0, 0)
    return canvas
}

const getVideoFrames = (source: File | string, length: number = 0, fps: number = FPS): Promise<CreationToolFrame[]> =>
    new Promise((resolve, reject) => {
        const video = document.createElement('video')
        const frames: CreationToolFrame[] = []
        let totalFrames = length
        let currentFrame = 0

        video.onseeked = () => {
            video.pause()
            frames.push({ canvas: drawToCanvas(video) })
            currentFrame++

            if (currentFrame < totalFrames) {
                video.currentTime = (currentFrame / totalFrames) * video.duration
            } else {
                video.onseeked = null
                if (typeof source !== 'string') {
                    URL.revokeObjectURL(video.src)
                }
                resolve(frames)
            }
        }

        video.oncanplaythrough = () => {
            if (!video.videoWidth || !video.videoHeight) {
                reject(`Invalid dimensions`)
            } else {
                totalFrames = totalFrames || Math.floor(video.duration / fps)
                video.oncanplaythrough = null
                video.currentTime = 0.01
            }
        }

        video.onerror = err => {
            reject(err)
        }

        video.preload = 'auto'
        video.src = typeof source === 'string' ? source : URL.createObjectURL(source)
    })

export default getVideoFrames
